<template>
  <div>
    <el-dialog
      :visible.sync="$root.bindPhoneVisible"
      width="470px"
      :before-close="handleClose"
    >
      <div class="pwd">
        <div class="box">
          <div class="regist-tit">绑定手机号</div>

          <div class="list" style="padding-top:20px">
            <el-form :model="loginForm" status-icon>
              <el-form-item>
                <!-- <p class="hint-login">可使用老子云账号登录</p> -->
                <el-input
                  v-model.trim="loginForm.phone"
                  class="check-inp"
                  maxlength="11"
                  name="phone"
                  placeholder="请输入手机号"
                  @focus="mobileFocus"
                  @blur="mobileBlur"
                >
                  <i
                    slot="prefix"
                    class="iconfont iconzhanghao"
                    ref="account"
                  />
                </el-input>
              </el-form-item>

              <div class="puzzle" >
                <Puzzle  @adopt="adopt" />
              </div>

              <sendCode
              ref="sendCode"
              v-model="loginForm.code"
              :phone="loginForm.phone"
              type="bindPhone"
              @getSmsKey="getSmsKey"
            />

              <el-form-item prop="professionCode">
                <el-select
                  v-model="loginForm.professionCode"
                  class="check-inp"
                  placeholder="请选择职业"
                  suffix-icon="el-icon-date"
                >
                  <template slot="prefix"
                    ><i class="iconfont iconzhiye"></i
                  ></template>

                  <el-option label="应用开发者" value="appdeveloper" />
                  <el-option label="模型师" value="modeler" />
                  <el-option label="设计师" value="designer" />
                  <el-option label="其他" value="other" />
                </el-select>
              </el-form-item>
            </el-form>

            <el-button
              round
              class="btn-blue lb"
              @click="next"
              data-agl-cvt="5"
              >确定</el-button
            >

            <!-- <div class="helper">
              <span style="color:#1458EA">返回登录</span>
            </div> -->
          </div>
        </div>
      </div>
    </el-dialog>
    <!---注册协议-->
    <agreement></agreement>
    <div class="layout" v-show="showQrCode">
        <div class="inner">
            <h5>
                恭喜你，注册成功！<br/>
                <!-- 扫码添加客服立即获取平台 <span style="color: #1458EA;">免费消费</span> 权益 -->
                {{this.popupData.tipText}}
            </h5>
             <!-- <img :src="'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/QRCode/qrcode.png?time='+timestamp" /> -->
            <img :src="'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' + this.popupData.img" />
            <p>扫一扫 即可免费获取</p>
            <button @click="jump">我知道了</button>
        </div>
    </div>

      <invitationCode v-model="showCode2" @handle="closeView" />

  </div>
</template>

<script>
import {
  validatePhoneEmail,
  validatePhone,
  validatePwd,
} from "@/utils/validate";
import sendCode from "@/components/sendCode";
import Puzzle from "@/components/aliPuzzle";
import thirdLogin from "@/components/thirdLogin";
import agreement from "@/components/agreement";
import register from "@/components/register";
import { api_relatedPhone } from '@/api/login'
import invitationCode from '@/components/invitationCode'
import { mapMutations, mapState, mapActions } from 'vuex'
import userInfo from '@/mixins/userInfo'
import Cookie from "js-cookie"
export default {
     mixins: [userInfo],
  components: {
    sendCode,
    Puzzle,
    thirdLogin,
    agreement,
    register,
    invitationCode
  },
  data() {
    return {
      codeTxt: '发送验证码',
      loginForm: {
        phone: '',
        code: '',
        professionCode: ''
      },
      codeRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }]
      },
      verification: false,
      showCode: false,
      showCode2: false,
      showQrCode: false,
      smsKey: '',
      popupData:{
          img:'',
          status:'',
          tipText:'',
      },
      popupStatus:'',
    }
  },
  computed: {
    ...mapState("login", {
      openId: state => {
        return state.openId
      },
      thirdAvatar: state => {
        return state.thirdAvatar
      },
      thirdNickName: state => {
        return state.thirdNickName
      },
      loginMethod: state => {
        return state.loginMethod
      },
      isAgree: state => {
        return state.isAgree
      },
      registerData: state => {
        return state.registerData
      }
    })
  },
    watch: {
    loginForm: {
      handler: function(n) {
        n.code = n.code.replace(/[^\d]/g, '')
        n.phone = n.phone.replace(/[^\d]/g, '')
      },
      deep: true
    }
  },
  mounted() {
    const _this = this
    // document.onkeydown = function(e) {
    //   const key = window.event.keyCode
    //   if (key === 13) {
    //     _this.next() //方法
    //   }
    // }
     this.getInfo();
    
  },
//   beforeDestroy() {
//     document.onkeydown = function() {
//       const key = window.event.keyCode
//       if (key == 13) {
//         console.log('13')
//       }
//     }
//   },
  methods: {
      ...mapMutations({
      SETAUTHORIZATION: "login/SETAUTHORIZATION",
      ISLOGINTOASTSHOW: "login/ISLOGINTOASTSHOW",
      SETAGREEMENTPATH: "login/SETAGREEMENTPATH",
      SETISAGREE: "login/SETISAGREE",
      SETREGISTERDATA: "login/SETREGISTERDATA",
      ISREGISTER: "login/ISREGISTER",
      LOGINTOASTTYPE: "login/LOGINTOASTTYPE",
    }),
    ...mapActions("login", {
      GETUSERINFO: "GETUSERINFO",
    }),
        handleClose(done) {

            done();

      },
      mobileFocus(){
        //   var icon=document.getElementsByClassName('iconzhanghao');
          this.$refs.account.style.color='#1458EA';
      },
       mobileBlur(){
        //   var icon=document.getElementsByClassName('iconzhanghao');
          this.$refs.account.style.color='#9E9FAB';
      },
      getInfo(){
    this.axios
        .post('/api-personal/laozi/v3/common/unauth/getPopupSettings')
        .then(res => {
        if (res.resp_code == 60000) {
            this.popupData=res.datas;
            
        } else {
            this.$message.error(res.resp_msg)
        }
        })
    },
        //获取弹窗信息
    getPopupInfo(){
      this.axios
        .post('/api-personal/laozi/v3/common/unauth/getPopupSettings')
        .then(res => {
          if (res.resp_code == 60000) {
            this.popupStatus=res.datas.status;
            if(this.popupStatus==1){
              this.$emit('handle');
            }else if(this.popupStatus==0){
            //    this.$router.push({ path: '/' })
            //  this.goReturnUrl()
            }
            
          } else {
            this.$message.error(res.resp_msg)
          }
        })
    },
    jump(){
        this.showQrCode = false
        this.goReturnUrl()
    },
    //推广码
    closeView() {
      this.showCode2 = false;
     
      if(this.popupStatus==0){
        this.showQrCode = false;
        this.goReturnUrl()
       }else if(this.popupStatus==1){
           this.showQrCode = true;
       }
    },
    getSmsKey(val) {
      this.smsKey = val
    },
    adopt() {
      this.verification = true
      this.$refs.sendCode.getCode()
    },
    next() {

      if (!this.loginForm.phone) {
        this.$message.error('请输入手机号')
        return
      }
    //   if (!this.testPhone(this.loginForm.phone)) {
    //     this.$message.error('请输入正确的手机号')
    //     return
    //   }
      if (!this.loginForm.professionCode) {
        this.$message.error('请选择职业')
        return
      }
      if (!this.smsKey) {
        this.$message.error('请获取验证码')
        return
      }
      if (!this.loginForm.code) {
        this.$message.error('请输入验证码')
        return
      }
      if (!/^[0-9]*$/.test(this.loginForm.code)) {
        this.$message.error('请输入正确的验证码')
        return
      }
      this.loginByCode()
    },
    async loginByCode() {
      const obj = {
        applisource: '',
        avatar: this.thirdAvatar,
        machineCode: '',
        nickName: this.thirdNickName,
        openId: this.openId,
        password: '123456',
        phoneno: this.loginForm.phone,
        platform: '',
        registerMethod: this.loginMethod == 'WX' ? 'weixin' : 'qq',
        smsCode: this.loginForm.code,
        professionCode: this.loginForm.professionCode,
        isJson: true,
        smsKey: this.smsKey
      }
      console.log(this.openId);
      console.log(obj);
      var domain = process.env.MODE == 'pro' ? 'twinsearth.laozicloud.com' : 'twinsearth.laozicloud.net'
        if(location.origin.includes('localhost')){
            domain = ''
        }
       Cookie.set('detection', true, { domain: domain })
      const res = await api_relatedPhone(obj)

      if (res.resp_code == 60000) {
        const J = JSON.parse(res.datas)
         this.getAppuserinfoTwo(J.access_token, () => {
                // this.goReturnUrl();
                });
        this.GETUSERINFO();
        window._agl && window._agl.push(['track', ['success', {t: 3}]])
        this.$message.success({
          showClose: true,
          message: '登录成功',
          type: 'success'
        })
        this.$root.bindPhoneVisible=false
        this.showCode = true
        this.getPopupInfo();
        this.showCode2 = true
      } else {
        this.$message.error(res.resp_msg)
      }
    },
    close() {
      this.showCode = false
      this.goReturnUrl()
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
}

/deep/ .el-select .el-input .el-select__caret::before {
  content: "\e78f";
}
/deep/ .el-dialog__headerbtn {
  top: 30px;
  font-size: 19px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #182c49;
  position: relative;
  z-index: 99999;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
.pwd {
  .regist-tit {
    font-size: 20px;
    color: #182c49;
    text-align: center;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6e9f0;
  }
  .el-dialog__body {
    padding: 35px 20px;
  }
  .hint-login {
    font-size: 12px;
    color: #c0c3c8;
    margin-left: 11px;
  }
}
/deep/.el-button.is-disabled,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-color: #ddd;
  border-color: #ebeef5;
}

.foot-text {
  position: absolute;
  bottom: -35px;
  left: 50px;
  color: #fff;
}

.pwd {
  //   background: url('../assets/img/bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  .text-wa {
    position: absolute;
    color: #ffffff;
    top: 35%;
    left: 29%;
    line-height: 33px;
  }

  .container-page {
    width: 1180px;
    margin: 0 auto;
  }
  .box {
    background: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;
    .helper {
      display: flex;
      justify-content: center;
      width: 320px;
      margin-top: 15px;
      font-size: 16px;
      /deep/ .el-checkbox__label {
        color: #0055f3;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #0055f3;
        border-color: #0055f3;
      }
      /deep/ .el-checkbox {
        vertical-align: middle;
      }
      .right {
        color: #8192a8;
        cursor: pointer;
        width: 100%;
        text-align: center;
        font-size: 14px;
        span {
          &:hover {
            color: #0055f3;
          }
        }
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      padding-top: 90px;
      .icon {
        color: #8192a8;
        font-size: 18px;
      }
      .puzzle {
        user-select: none;
        // margin-bottom: 20px;
      }
      .lb {
        width: 320px;
        height: 50px;
        border-radius: 40px;
        margin-left: 0;
        margin-top: 20px;
        /deep/ span {
          font-size: 16px;
        }
      }

      .login-btn {
        width: 320px;
        height: 60px;
        border-radius: 40px;
        background-color: #0055f3;
        color: #fff;
        text-align: center;
        line-height: 60px;
        margin-top: 25px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 85, 243, 0.12);
        }
        span {
          text-align: center;
          font-size: 16px;
        }
      }
      .register {
        position: absolute;
        top: 255px;
        display: flex;
        align-items: center;
        border: solid 1px #ffbb8e;
        background-color: rgba(245, 82, 49, 0.12);
        height: 40px;
        width: 308px;
        border-radius: 4px;
        padding-left: 10px;
        p {
          color: #8192a8;
          font-size: 12px;
        }
        span {
          color: #ff1616;
          font-size: 12px;
          cursor: pointer;
        }
        i {
          color: #ff1616;
        }
      }
      .block {
        width: 340px;
        margin-left: 40px;
      }
      .tit {
        margin-right: 10px;
      }
    }
    .tab {
      text-align: center;
      padding: 0 30px;
      border-bottom: 1px solid #e6e9f0;
      li:first-child {
        // margin-right: 50px;
      }
      li {
        cursor: pointer;
        color: #132c4b;
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 4px solid transparent;
        white-space: nowrap;
        display: inline-block;
        margin-left: 23px;
        position: relative;
        &:nth-child(1) {
          &::after {
            display: inline-block;
            content: "";
            width: 1px;
            height: 11px;
            background: #8b8b8b;
            position: absolute;
            right: 6px;
            top: 10px;
          }
        }
        span {
          font-size: 14px;
          display: block;
          transform: translate(-18px);
          font-weight: bold;
        }
      }
      .on {
        color: #1458ea;
        span {
          font-size: 20px;
        }
      }
    }
  }
}
.check-inp {
  width: 320px;
}

.code-inp {
  width: 200px;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-input__inner {
  background-color: #e4e9f3;
}
.hide-check-icon {
  /deep/.el-input__suffix {
    /deep/.el-input__validateIcon {
      display: none;
    }
  }
}
.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}

.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}

/deep/.el-input__inner:focus {
  color: #1458ea;
  border-color: #1458ea;
}
/deep/ .el-input__prefix:focus {
  color: #1458ea;
}
.layout{
    width: 100vw; height: 100vh; background-color: rgba(0,0,0,0.5); position: fixed; top: 0; left: 0; z-index: 999; display: flex; justify-content: center; align-items: center;
    .inner{
        width: 540px;height: 666px;background-color: #FFF; border-radius: 10px; display: flex; flex-direction: column; align-items: center;
        h5{
            text-align: center; margin: 40px 0 20px 0; position: relative; line-height: 40px; font-size: 24px;
            span{font-size: 24px;}
            &::after{content: ''; position: absolute; bottom: -20px; left: 50%; width: 68px; height: 4px; background-color: #1458ea; transform: translateX(-50%);}
        }
        >img{width: 262px; margin: 20px 0;margin-top:40px;}
        >p{
            text-align: center; color: #C3C6CB; position: relative; margin: 20px 0;font-size:14px;
             &::before{content: ''; position: absolute; display: block; width: 100px; height: 1px; background: #F2F2F2;top: 9px; left: -100%;}
            &::after{content: ''; position: absolute; display: block; width: 100px; height: 1px; background: #F2F2F2;bottom: 8px; right: -100%;}
        }
        button{
            width: 180px; height: 48px;background-color: #1458EA; border-radius: 24px; border: none;color: #FFF;margin-top: 50px; cursor: pointer;
        }
    }
}
</style>
